<template>
  <div class="help-main">
    <CommonHeader v-if="!$independence"></CommonHeader>
    <div class="menu-bar" id="headTop">
      <button class="goback themeGoBut" style="cursor: pointer" @click="goback">返回</button>
      <el-tree default-expand-all :data="data" :props="defaultProps" @node-click="handleNodeClick"
        :expand-on-click-node="isopen" :highlight-current="true">
      </el-tree>
    </div>
    <div v-if="!hospitalFlag" class="wrap">
      <div v-if="label =='上手指南'">
        <div class="wrap-two">
          <span class="wrap-two-header">上手指南</span>
          <!-- <video
            src="https://pro-zkfy.oss-cn-beijing.aliyuncs.com/assets/video/cat-base-course.mp4?OSSAccessKeyId=LTAI4FsekZZ3RfUHUxcvgV4F&Expires=2445391601&Signature=VcBwfUAu%2FYyQ5BfDpuCISq%2Bjte8%3D"
            controls width="800"></video> -->
          <h3>第一步、登录/注册</h3>
          <img src="../assets/imgs/help/01.png" alt="简介">
          <p>用户微信扫码登录/注册，如首次登录，需要输入企业码和手机号等相关信息。</p>
          <img src="../assets/imgs/help/02.png" alt="">
          <h3>第二步、新建项目</h3>
          <p>2.1. 上传文件：上传1个或多个待翻译文件并进行项目设置。</p>
          <img src="../assets/imgs/help/03.png" alt="">
          <p>点击或拖放上传文件，支持docx、doc、pdf、xlsx、xls、ppt、pptx、html等格式，单个文件大小不超过20MB。注意：同一项目上传的文件必须是同一源语言。</p>
          <img src="../assets/imgs/help/04.png" alt="">
          <p>选择源语言和目标语言（中英支持多个垂直领域）之后，进入下一步项目设置页面</p>
          <p>2.2. 项目设置</p>
          <img src="../assets/imgs/help/lt_corpus_free.png" alt="">
          <p>平台会自动挂载用户主记忆库中可用的记忆库/术语库，用户可选择取消或上传本地记忆库/术语库。（高校版支持作业模式，作业模式下，不拆分文件、不锁定重复，适合教学和翻译实践场景。）</p>
          <h3>第三步、项目列表</h3>
          <p>项目列表页可查看项目语言对、字数等信息。点击文件名或“查看”按钮，进入编辑器。</p>
          <img src="../assets/imgs/help/lt_see.png" alt="">
          <h3>第四步、编辑器</h3>
          <p>用户可在右侧译文区对机器预翻译的译文进行译后编辑。编辑完成后，可选择下载译文、原文、原译上下对照等格式的文件。</p>
          <img class="distance" src="../assets/imgs/help/lt_editor.png" alt="">
        </div>
      </div>
      <div v-if="label =='进阶指南'">
        <div class="wrap-two">
          <span class="wrap-two-header">进阶指南</span>
          <!-- <video
            src="https://pro-zkfy.oss-cn-beijing.aliyuncs.com/assets/video/cat-advanced-course.mp4?OSSAccessKeyId=LTAI4FsekZZ3RfUHUxcvgV4F&Expires=2445391511&Signature=Y%2BF5SgT%2Bp1%2B6b%2Fw39cFmiFC1tpc%3D"
            controls width="800"></video> -->
          <h3>第一步、登录/注册</h3>
          <img src="../assets/imgs/help/01.png" alt="简介">
          <p>用户微信扫码登录/注册，如首次登录，需要输入企业码和手机号等相关信息。</p>
          <img src="../assets/imgs/help/02.png" alt="">
          <h3>第二步、新建项目</h3>
          <p>上传1个或多个待翻译文件并进行项目设置。</p>
          <img src="../assets/imgs/help/03.png" alt="">
          <p>点击或拖放上传文件，支持docx、doc、pdf、xlsx、xls、ppt、pptx、html等格式，单个文件大小不超过20MB。注意：同一项目上传的文件必须是同一源语言。</p>
          <h3>第三步、项目设置</h3>
          <img src="../assets/imgs/help/lt_corpus_free.png" alt="">
          <p>平台会自动挂载用户主记忆库中可用的记忆库/术语库，用户可选择取消或上传本地记忆库/术语库。（高校版支持作业模式，作业模式下，不拆分文件、不锁定重复，适合教学和翻译实践场景。）</p>
          <h3>第四步、我的项目</h3>
          <p>用户可在我的项目列表页查看和管理翻译翻译项目，包括查看项目文件，指定译员，指定交付时间，管理项目记忆库术语库，新增项目文件、查看项目统计，下载或删除文件。</p>
          <img src="../assets/imgs/help/lt_project.png" alt="">
          <p>4.1. 项目设置</p>
          <img src="../assets/imgs/help/lt_set_up.png" alt="">
          <p>项目列表点击操作下“项目设置”可编辑项目名称，查看领域；管理项目挂载的记忆库术语库。</p>
          <img src="../assets/imgs/help/lt_project_details.png" alt="">
          <p>4.2. 指定译员</p>
          <img src="../assets/imgs/help/lt_designated_interpreter.png" alt="">
          <p>在项目列表点击操作下“指定译员”指定给1名或最多10名译员，支持设置截止时间和单价。指定给多名译员的文件将均分，译员可实时翻译编辑同一份文件。注意：指定译员后，如译员开始翻译文件，则暂不支持重新指定译员。</p>
          <h3>第五步、我的任务</h3>
          <p>被指定的译员可在我的任务页面管理被指定的翻译任务，任务逾期后，交付日期会显示为红色。项目经理可以直接在我的项目列表，操作下点击“查看”进入编辑器查看。</p>
          <img src="../assets/imgs/help/lt_my_mission.png" alt="">
          <h3>第六步、编辑器</h3>
          <p>飞译CAT编辑器整合强大的在线编辑功能，页面所见即所得。除了在线编辑器具备的编辑、查找替换， 具备独具特色的辅助翻译功能。主要功能如下：</p>
          <img src="../assets/imgs/help/lt_editor.png" alt="">
          <p><span class="careful">锁定重复：</span>对于重复句段，第一句可编辑，其他句段不可编辑，在译后编辑全部完成后系统会自动替换。</p>
          <p><span class="careful">交互式翻译（单词补全）：</span>如译文为英文，在译文编辑过程中，如用户对译文做修改，系统会自动提示单词全拼，点击“Enter”或“→”即可快速输入译文。</p>
          <p><span class="careful">术语提示：</span>用户光标处于某个正在编辑的译文句段时，右侧“翻译建议”提示区域会提示该句段和用户术语库匹配的术语。</p>
          <p>
            <span class="careful">添加术语：</span>
            用户在翻译过程中，可随时添加术语。方式一：点击“添加术语”，右侧提示区出现“添加术语”，输入原文译文可添加。方式二：选中原文词语，鼠标右键显示”添加术语”，选择添加术语，右侧提示区出现“添加术语”，输入原文译文可添加。
          </p>
          <p> <span class="careful">查词：</span>点击上方功能区“查词”，在“翻译建议”区输入中英文单词可查在线词典。或选中单词后鼠标右键，点击“查词”亦可查词。</p>
          <p> <span class="careful">提交任务：</span>确认全文译后编辑完成后，点击“提交任务”，任务列表和项目列表页面译后编辑进度将变为100%。</p>
          <p> <span class="careful">下载：</span>用户可在编辑器选择下载译文、原文、原译上下对照等格式的文件。</p>
          <p> <span class="careful  distance">添加到记忆库：</span> 翻译完成之后，用户可将译后编辑后的全文添加到记忆库中，供后续项目复用。</p>
        </div>
      </div>
      <div v-if="label =='飞译CAT简介'">
        <div class="wrap-two">
          <span class="wrap-two-header">飞译CAT完整手册</span>
          <h3>飞译CAT简介</h3>
          <p class="wrap-two-p1">飞译CAT是北京中科凡语科技有限公司自主研发的多语言人机合译平台。平台提供高质量的多语言
            机器预翻译、多格式文档处理、在线翻译、高效的项目管理、多人实时协作、团队管理等功能。</p>
          <img src="../assets/imgs/help/01.png" alt="简介">
          <h3>飞译CAT特点</h3>
          <ul class="wrap-two-p2">
            <li>精准预翻译：垂直领域医疗翻译引擎，更精准的预翻译；</li>
            <li>术语自定义：支持用户添加术语，在预翻译过程中直接替换术语，更懂用户；</li>
            <li>寓繁于简：极简操作，让专业的你专注自己专业的事；</li>
            <li>所见即所得：首款所见即所得的在线翻译界面，全新翻译体验；</li>
            <li>多人协作：简单直观的多人协作方式，多人协作从未如此简单</li>
          </ul>
          <h3>支持格式</h3>
          <p class="wrap-two-p3">支持docx、doc、pdf、xlsx、txt、xls、ppt、pptx、html等格式。单个文件大小不超过20MB。</p>
        </div>
      </div>
      <div v-if="label =='新建项目'">
        <div class="wrap-two">
          <span class="wrap-two-header">新建项目</span>
          <h3>新建项目</h3>
          <p>上传1个或多个待翻译文件并进行项目设置。</p>
          <h3>1.1.上传文件</h3>
          <img src="../assets/imgs/help/03.png" alt="上传文件">
          <p>点击或拖放上传文件，支持docx、doc、pdf、xlsx、xls、ppt、pptx、html等格式，单个文件大小不超过20MB。</p>
          <span class="careful">注意：</span>
          <span>同一项目上传的文件必须是同一源语言。</span>
          <img src="../assets/imgs/help/04.png" alt="">
          <p>上传文件后，用户可查看上传状态、字数、源语言等信息，单个或批量删除已上传文件。选择语言对之后，进入下一步项目设置页面。</p>
          <h3>1.2.项目设置</h3>
          <img src="../assets/imgs/help/05.png" alt="">
          <p>
            记忆库术语库分别展示用户已上传到平台的翻译记忆库和翻译术语库，且已根据项目语言对进行过筛选，用户可默认将已展示的记忆库术语库挂载到本项目，或关闭记忆库前的开关取消挂载。<strong>用户挂载的术语可以在预翻译过程中直接替换。</strong>
          </p>
          <img src="../assets/imgs/help/list.png" alt="">
          <p class="distance">指定项目名称和领域后，点击完成进入翻译项目列表页面。</p>
        </div>
      </div>
      <div v-if="label =='我的项目'">
        <div class="wrap-two">
          <span class="wrap-two-header">我的项目</span>
          <h3>我的项目</h3>
          <p>用户可在此页面查看和管理翻译项目，包括查看项目文件，指定译员，指定交付时间，管理项目记忆库术语库，新增项目文件、查看项目统计，下载或删除文件。</p>
          <img src="../assets/imgs/help/list.png" alt="">
          <h3>2.1.项目统计:</h3>
          <p>在项目行点击“项目统计”按钮。</p>
          <img src="../assets/imgs/help/statistics.png" alt="">
          <p>可查看本项目的文件字数、重复字数、记忆库术语库等数据统计，并可一键下载到本地。</p>
          <img src="../assets/imgs/help/project_statistics.png" alt="">
          <h3>译员工作量</h3>
          <img src="../assets/imgs/help/workload.png" alt="">
          <h3>2.2.项目记忆库</h3>
          <img src="../assets/imgs/help/selection_library.png" alt="">
          <p>可查看项目挂载的记忆库术语库，添加本地的记忆库术语库（可下载模板，根据模板格式上传）。</p>
          <h3>2.3.继续添加文件</h3>
          <img src="../assets/imgs/help/upload_files.png" alt="">
          <h3>指定译员</h3>
          <img class="distance" src="../assets/imgs/help/appointed_member.png" alt="">
        </div>
      </div>
      <div v-if="label =='翻译编辑器'">
        <div class="wrap-two">
          <span class="wrap-two-header">翻译编辑器</span>
          <h3>翻译编辑器</h3>
          <p>飞译CAT编辑器整合强大的在线编辑功能，页面所见即所得。除了在线编辑器具备的编辑、查找替换， 具备独具特色的辅助翻译功能。主要功能如下：</p>
          <img src="../assets/imgs/help/edit.png" alt="">
          <span class="careful">交互式翻译：</span>
          <span>如译文为英文，在译文编辑过程中，会自动提示单词全拼，点击“Enter”或“→”即可快速输入译文。</span><br>
          <span class="careful">锁定重复：</span>
          <span>对于重复句段，第一句可编辑，其他句段不可编辑，在译后编辑全部完成后系统会自动替换。</span><br>
          <span class="careful">术语提示：</span>
          <span>用户光标处于某个正在编辑的译文句段时，右侧“翻译建议”提示区域会提示该句段和用户术语库匹配的术语。</span><br>
          <img class="editor1" src="../assets/imgs/help/term_hint.png" alt=""><br>
          <span class="careful">添加术语：</span>
          <span>用户在翻译过程中，可随时添加术语。</span><br>
          <span class="careful">方式一：</span><br>
          <span>点击“添加术语”，右侧提示区出现“添加术语”，输入原文译文可添加。</span><br>
          <span class="careful">方式二：</span>
          <span>选中原文词语，鼠标右键显示，选择添加术语，右侧提示区出现“添加术语”，输入原文译文可添加。</span><br>
          <img class="editor1" src="../assets/imgs/help/right_click.png" alt="">&nbsp;&nbsp;&nbsp;&nbsp;
          <img class="editor1" src="../assets/imgs/help/add_terms.png" alt=""><br>
          <span class="careful">查词：</span>
          <span>点击上方功能区“查词”，在“翻译建议”区输入中英文单词可查在线词典。或选中单词后鼠标右键，点击“查词”亦可查词。</span><br>
          <span class="careful">下载：</span>
          <span>用户可在编辑器选择下载译文、原文、原译上下对照等格式的文件。 添加到记忆库：翻译完成之后，用户可将译后编辑后的全文添加到记忆库中，供后续项目复用。</span><br>
          <span class="careful">提交任务：</span>
          <span class="distance" style="display:block;">确认全文译后编辑完成后，点击“提交任务”，任务列表和项目列表页面译后编辑进度将变为100%。</span><br>
        </div>

      </div>
      <div v-if="label =='我的任务'">
        <div class="wrap-two">
          <span class="wrap-two-header">我的任务</span>
          <h3>我的任务</h3>
          <p>用户可在此页面管理被指定的翻译任务。</p>
          <img src="../assets/imgs/help/normal.png" alt="">
          <p>任务逾期后，交付日期会显示为红色。</p>
          <img class="distance" src="../assets/imgs/help/delay.png" alt="">
        </div>
      </div>
      <div v-if="label =='翻译记忆'">
        <div class="wrap-two">
          <span class="wrap-two-header">翻译记忆</span>
          <h3>翻译记忆</h3>
          <p>用户可管理自己账号下的记忆库和术语库。</p>
          <img src="../assets/imgs/help/memory.png" alt="">
          <p>点击上传按钮，可将本地记忆/术语库上传到已有记忆库，支持xlsx/txt/tmx（术语库格式为xlsx/txt/tbx）三种格式，用户可下载模板参考。</p>
          <img src="../assets/imgs/help/upload.png" alt="">
          <p>记忆/术语库详情：支持按条目单条或批量编辑、删除记忆/术语库。</p>
          <img src="../assets/imgs/help/memory_details.png" alt="">
          <p>点击添加可输入原文译文，按条添加记忆/术语库。</p>
          <img src="../assets/imgs/help/tianjiajiyi.png" alt="">
          <span class="careful" style="margin-top:30px">新建记忆/术语库：</span>
          <span>可上传本地记忆/术语库，并在系统独立生成一个记忆/术语库，支持xlsx/txt/tmx（术语库格式为xlsx/txt/tbx）三种格式，用户可下载模板参考。</span><br>
          <img src="../assets/imgs/help/choice.png" alt="">
          <span class="careful" style="margin-top:30px">合并记忆/术语库：</span>
          <img src="../assets/imgs/help/hbjyk.png" alt="">
          <p class="distance">选中2个以上相同语言方向的记忆/术语库，填写库名，选择领域后，可将多个记忆/术语库合并为一个 记忆/术语库。</p>
        </div>
      </div>
      <div v-if="label =='团队管理'">
        <div class="wrap-two">
          <span class="wrap-two-header">团队管理</span>
          <h3>团队管理</h3>
          <p>查看和管理翻译团队。</p>
          <img src="../assets/imgs/help/team_management.png" alt="">
          <p>点击“微信邀请成员”跳转页面，生成二维码邀请成员加入团队。</p>
          <img src="../assets/imgs/help/fenxiang.png" alt="">
          <p>被邀请者扫码后，新成员即可参与项目协作。</p>
          <p>被邀请加入后，用户将拥有2个空间，个人空间和被邀请加入的团队空间，空间的所有任务、项目、翻译记忆各自独立，用户可在右上角自由切换。</p>
          <img class="distance" src="../assets/imgs/help/team_management.png" alt="">
        </div>
      </div>
      <div v-if="label =='用户中心'">
        <div class="wrap-two">
          <span class="wrap-two-header">用户中心</span>
          <h3>用户中心</h3>
          <p>用户可在个人查看个人信息，选择擅长语言和擅长领域。</p>
          <img src="../assets/imgs/help/personal_center.png" alt="">
          <p>选择擅长语言（最多3个）：</p>
          <img src="../assets/imgs/help/field.png" alt="">
          <p>选择擅长领域（最多3个）：</p>
          <img class="distance" src="../assets/imgs/help/language_pairs.png" alt="">
        </div>
      </div>
    </div>
  <div v-if="hospitalFlag" class="wrap">
      <div v-if="label =='上手指南'">
        <div class="wrap-two">
          <span class="wrap-two-header">上手指南</span>
          <video v-if="isVideo"
            src="https://pro-zkfy.oss-cn-beijing.aliyuncs.com/assets/video/fycat-opt.mp4"
            controls width="800"></video>
            <!-- <video v-if="isVideo"
            src="https://pro-zkfy.oss-cn-beijing.aliyuncs.com/assets/video/cat-base-course.mp4?OSSAccessKeyId=LTAI4FsekZZ3RfUHUxcvgV4F&Expires=2445391601&Signature=VcBwfUAu%2FYyQ5BfDpuCISq%2Bjte8%3D"
            controls width="800"></video> -->
          <h3 v-if="!$independence">第一步、登录/注册</h3>
          <img v-if="!$independence" src="../assets/imgs/help/lt_sign_in.png" alt="简介">
          <p v-if="!$independence">支持账号密码、手机、邮箱注册和登录</p>
          <img v-if="!$independence" src="../assets/imgs/help/lt_register.png" alt="">
          <h3>第{{$independence ? '一' : '二'}}步、新建项目</h3>
          <p>{{$independence ? '1' : '2'}}.1. 上传文件：上传1个或多个待翻译文件并进行项目设置。</p>
          <img src="../assets/imgs/help/lt_newly_build.png" alt="">
          <p>点击或拖放上传文件，支持docx、doc、pdf、xlsx、xls、ppt、pptx、html等格式，单个文件大小不超过20MB。注意：同一项目上传的文件必须是同一源语言。</p>
          <img src="../assets/imgs/help/lt_choice_language.png" alt="">
          <p>选择源语言和目标语言（中英支持多个垂直领域）之后，进入下一步项目设置页面</p>
          <p>{{$independence ? '1' : '2'}}.2. 项目设置</p>
          <img src="../assets/imgs/help/lt_corpus_free.png" alt="">
          <p>平台会自动挂载用户主记忆库中可用的记忆库/术语库，用户可选择取消或上传本地记忆库/术语库。（高校版支持作业模式，作业模式下，不拆分文件、不锁定重复，适合教学和翻译实践场景。）</p>
          <h3>第{{$independence ? '二' : '三'}}步、项目列表</h3>
          <p>项目列表页可查看项目语言对、字数等信息。点击文件名或“查看”按钮，进入编辑器。</p>
          <img src="../assets/imgs/help/lt_see.png" alt="">
          <h3>第{{$independence ? '三' : '四'}}步、编辑器</h3>
          <p>用户可在右侧译文区对机器预翻译的译文进行译后编辑。编辑完成后，可选择下载译文、原文、原译上下对照等格式的文件。</p>
          <img class="distance" src="../assets/imgs/help/lt_editor.png" alt="">
        </div>
      </div>
      <div v-if="label =='进阶指南'">
        <div class="wrap-two">
          <span class="wrap-two-header">进阶指南</span>
          <!-- <video
            src="https://pro-zkfy.oss-cn-beijing.aliyuncs.com/assets/video/cat-advanced-course.mp4?OSSAccessKeyId=LTAI4FsekZZ3RfUHUxcvgV4F&Expires=2445391511&Signature=Y%2BF5SgT%2Bp1%2B6b%2Fw39cFmiFC1tpc%3D"
            controls width="800"></video> -->
          <h3 v-if="!$independence">第一步、登录/注册</h3>
          <img v-if="!$independence" src="../assets/imgs/help/lt_sign_in.png" alt="简介">
          <p v-if="!$independence">支持账号密码、手机、邮箱注册和登录</p>
          <img v-if="!$independence" src="../assets/imgs/help/lt_register.png" alt="">
          <h3>第{{$independence ? '一' : '二'}}步、新建项目</h3>
          <p>上传1个或多个待翻译文件并进行项目设置。</p>
          <img src="../assets/imgs/help/lt_newly_build.png" alt="">
          <p>点击或拖放上传文件，支持docx、doc、pdf、xlsx、xls、ppt、pptx、html等格式，单个文件大小不超过20MB。注意：同一项目上传的文件必须是同一源语言。</p>
          <h3>第{{$independence ? '二' : '三'}}步、项目设置</h3>
          <img src="../assets/imgs/help/lt_corpus_free.png" alt="">
          <p>平台会自动挂载用户主记忆库中可用的记忆库/术语库，用户可选择取消或上传本地记忆库/术语库。（高校版支持作业模式，作业模式下，不拆分文件、不锁定重复，适合教学和翻译实践场景。）</p>
          <h3>第{{$independence ? '三' : '四'}}步、我的项目</h3>
          <p>用户可在我的项目列表页查看和管理翻译翻译项目，包括查看项目文件，指定译员，指定交付时间，管理项目记忆库术语库，新增项目文件、查看项目统计，下载或删除文件。</p>
          <img src="../assets/imgs/help/lt_project.png" alt="">
          <p>{{$independence ? '3' : '4'}}.1. 项目设置</p>
          <img src="../assets/imgs/help/lt_set_up.png" alt="">
          <p>项目列表点击操作下“项目设置”可编辑项目名称，查看领域；管理项目挂载的记忆库术语库。</p>
          <img src="../assets/imgs/help/lt_project_details.png" alt="">
          <p>{{$independence ? '3' : '4'}}.2. 指定译员</p>
          <img src="../assets/imgs/help/lt_designated_interpreter.png" alt="">
          <p>在项目列表点击操作下“指定译员”指定给1名或最多10名译员，支持设置截止时间和单价。指定给多名译员的文件将均分，译员可实时翻译编辑同一份文件。注意：指定译员后，如译员开始翻译文件，则暂不支持重新指定译员。</p>
          <h3>第{{$independence ? '四' : '五'}}步、我的任务</h3>
          <p>被指定的译员可在我的任务页面管理被指定的翻译任务，任务逾期后，交付日期会显示为红色。项目经理可以直接在我的项目列表，操作下点击“查看”进入编辑器查看。</p>
          <img src="../assets/imgs/help/lt_my_mission.png" alt="">
          <h3>第{{$independence ? '五' : '六'}}步、编辑器</h3>
          <p>飞译CAT编辑器整合强大的在线编辑功能，页面所见即所得。除了在线编辑器具备的编辑、查找替换， 具备独具特色的辅助翻译功能。主要功能如下：</p>
          <img src="../assets/imgs/help/lt_editor.png" alt="">
          <p><span class="careful">锁定重复：</span>对于重复句段，第一句可编辑，其他句段不可编辑，在译后编辑全部完成后系统会自动替换。</p>
          <p><span class="careful">交互式翻译（单词补全）：</span>如译文为英文，在译文编辑过程中，如用户对译文做修改，系统会自动提示单词全拼，点击“Enter”或“→”即可快速输入译文。</p>
          <p><span class="careful">术语提示：</span>用户光标处于某个正在编辑的译文句段时，右侧“翻译建议”提示区域会提示该句段和用户术语库匹配的术语。</p>
          <p>
            <span class="careful">添加术语：</span>
            用户在翻译过程中，可随时添加术语。方式一：点击“添加术语”，右侧提示区出现“添加术语”，输入原文译文可添加。方式二：选中原文词语，鼠标右键显示”添加术语”，选择添加术语，右侧提示区出现“添加术语”，输入原文译文可添加。
          </p>
          <p> <span class="careful">查词：</span>点击上方功能区“查词”，在“翻译建议”区输入中英文单词可查在线词典。或选中单词后鼠标右键，点击“查词”亦可查词。</p>
          <p> <span class="careful">提交任务：</span>确认全文译后编辑完成后，点击“提交任务”，任务列表和项目列表页面译后编辑进度将变为100%。</p>
          <p> <span class="careful">下载：</span>用户可在编辑器选择下载译文、原文、原译上下对照等格式的文件。</p>
          <p> <span class="careful  distance">添加到记忆库：</span> 翻译完成之后，用户可将译后编辑后的全文添加到记忆库中，供后续项目复用。</p>
        </div>
      </div>
      <div v-if="label =='飞译CAT简介'">
        <div class="wrap-two">
          <span class="wrap-two-header">飞译CAT完整手册</span>
          <h3>飞译CAT简介</h3>
          <p class="wrap-two-p1">飞译CAT是北京中科凡语科技有限公司自主研发的多语言人机合译平台。平台提供高质量的多语言
            机器预翻译、多格式文档处理、在线翻译、高效的项目管理、多人实时协作、团队管理等功能。</p>
          <img src="../assets/imgs/help/home_page.png" alt="简介">
          <h3>飞译CAT特点</h3>
          <ul class="wrap-two-p2">
            <li>寓繁于简：极简操作，让专业的你专注自己专业的事。</li>
            <li>所见即所得：首款所见即所得的在线翻译界面，全新翻译体验。</li>
            <li>精准预翻译：神经网络机器翻译，精准预翻译加持，中英细分为7个领域；</li>
            <li>人机合译：结合公司强大算法优势，在翻译过程中实时人机互动，人机合译，共同进步。</li>
            <li>多人协作：简单直观的多人协作方式，多人协作从未如此简单</li>
          </ul>
          <h3>语种支持（32）</h3>
          <p class="wrap-two-p3">
            中文和英语、日语、俄语、韩语、法语、德语、西班牙语、葡萄牙语、意大利语、泰语、越南语、阿拉伯语、希腊语、希伯来语、荷兰语、波兰语、保加利亚语、爱沙尼亚语、丹麦语、芬兰语、捷克语、罗马尼亚语、斯洛文尼亚语、瑞典语、乌克兰语、匈牙利语、土耳其语、印尼语、马来语、印地语、波斯语互译
          </p>
          <h3>支持格式</h3>
          <p class="wrap-two-p3">支持docx、doc、pdf、xlsx、txt、xls、ppt、pptx、html等格式。单个文件大小不超过20MB。</p>
        </div>
      </div>
      <div v-if="label =='新建项目'">
        <div class="wrap-two">
          <span class="wrap-two-header">新建项目</span>
          <h3>新建项目</h3>
          <p>上传1个或多个待翻译文件并进行项目设置。</p>
          <h3>1.1.上传文件</h3>
          <img src="../assets/imgs/help/new_file.png" alt="上传文件">
          <p>点击或拖放上传文件，支持docx、doc、pdf、xlsx、xls、ppt、pptx、html等格式，单个文件大小不超过20MB。</p>
          <span class="careful">注意：</span>
          <span>同一项目上传的文件必须是同一源语言。</span>
          <img src="../assets/imgs/help/uploading.png" alt="">
          <p>上传文件后，用户可查看上传状态、字数、源语言等信息，单个或批量删除已上传文件。选择语言对之后，进入下一步项目设置页面。</p>
          <h3>1.2.项目设置</h3>
          <img src="../assets/imgs/help/project_settings.png" alt="">
          <p>记忆库术语库分别展示用户已上传到平台的翻译记忆库和翻译术语库，且已根据项目语言对进行过筛选，用户可默认将已展示的记忆库术语库挂载到本项目，或点击带文件名的库名取消挂载。</p>
          <img src="../assets/imgs/help/list.png" alt="">
          <p class="distance">指定项目名称和领域后，点击完成进入翻译项目列表页面。</p>
        </div>
      </div>
      <div v-if="label =='我的项目'">
        <div class="wrap-two">
          <span class="wrap-two-header">我的项目</span>
          <h3>我的项目</h3>
          <p>用户可在此页面查看和管理翻译项目，包括查看项目文件，指定译员，指定交付时间，管理项目记忆库术语库，新增项目文件、查看项目统计，下载或删除文件。</p>
          <img src="../assets/imgs/help/list.png" alt="">
          <h3>2.1.项目统计:</h3>
          <p>在项目行点击“项目统计”按钮。</p>
          <img src="../assets/imgs/help/statistics.png" alt="">
          <p>可查看本项目的文件字数、重复字数、记忆库术语库等数据统计，并可一键下载到本地。</p>
          <img src="../assets/imgs/help/project_statistics.png" alt="">
          <h3>译员工作量</h3>
          <img src="../assets/imgs/help/workload.png" alt="">
          <h3>2.2.项目记忆库</h3>
          <img src="../assets/imgs/help/selection_library.png" alt="">
          <p>可查看项目挂载的记忆库术语库，添加本地的记忆库术语库（可下载模板，根据模板格式上传）。</p>
          <h3>2.3.继续添加文件</h3>
          <img src="../assets/imgs/help/upload_files.png" alt="">
          <h3>指定译员</h3>
          <img class="distance" src="../assets/imgs/help/appointed_member.png" alt="">
        </div>
      </div>
      <div v-if="label =='翻译编辑器'">
        <div class="wrap-two">
          <span class="wrap-two-header">翻译编辑器</span>
          <h3>翻译编辑器</h3>
          <p>飞译CAT编辑器整合强大的在线编辑功能，页面所见即所得。除了在线编辑器具备的编辑、查找替换， 具备独具特色的辅助翻译功能。主要功能如下：</p>
          <img src="../assets/imgs/help/edit.png" alt="">
          <span class="careful">交互式翻译：</span>
          <span>如译文为英文，在译文编辑过程中，会自动提示单词全拼，点击“Enter”或“→”即可快速输入译文。</span><br>
          <span class="careful">锁定重复：</span>
          <span>对于重复句段，第一句可编辑，其他句段不可编辑，在译后编辑全部完成后系统会自动替换。</span><br>
          <span class="careful">术语提示：</span>
          <span>用户光标处于某个正在编辑的译文句段时，右侧“翻译建议”提示区域会提示该句段和用户术语库匹配的术语。</span><br>
          <img class="editor1" src="../assets/imgs/help/term_hint.png" alt=""><br>
          <span class="careful">添加术语：</span>
          <span>用户在翻译过程中，可随时添加术语。</span><br>
          <span class="careful">方式一：</span><br>
          <span>点击“添加术语”，右侧提示区出现“添加术语”，输入原文译文可添加。</span><br>
          <span class="careful">方式二：</span>
          <span>选中原文词语，鼠标右键显示，选择添加术语，右侧提示区出现“添加术语”，输入原文译文可添加。</span><br>
          <img class="editor1" src="../assets/imgs/help/right_click.png" alt="">&nbsp;&nbsp;&nbsp;&nbsp;
          <img class="editor1" src="../assets/imgs/help/add_terms.png" alt=""><br>
          <span class="careful">查词：</span>
          <span>点击上方功能区“查词”，在“翻译建议”区输入中英文单词可查在线词典。或选中单词后鼠标右键，点击“查词”亦可查词。</span><br>
          <span class="careful">下载：</span>
          <span>用户可在编辑器选择下载译文、原文、原译上下对照等格式的文件。 添加到记忆库：翻译完成之后，用户可将译后编辑后的全文添加到记忆库中，供后续项目复用。</span><br>
          <span class="careful">提交任务：</span>
          <span class="distance" style="display:block;">确认全文译后编辑完成后，点击“提交任务”，任务列表和项目列表页面译后编辑进度将变为100%。</span><br>
        </div>

      </div>
      <div v-if="label =='我的任务'">
        <div class="wrap-two">
          <span class="wrap-two-header">我的任务</span>
          <h3>我的任务</h3>
          <p>用户可在此页面管理被指定的翻译任务。</p>
          <img src="../assets/imgs/help/normal.png" alt="">
          <p>任务逾期后，交付日期会显示为红色。</p>
          <img class="distance" src="../assets/imgs/help/delay.png" alt="">
        </div>
      </div>
      <div v-if="label =='翻译记忆'">
        <div class="wrap-two">
          <span class="wrap-two-header">翻译记忆</span>
          <h3>翻译记忆</h3>
          <p>用户可管理自己账号下的记忆库和术语库。</p>
          <img src="../assets/imgs/help/memory.png" alt="">
          <p>点击上传按钮，可将本地记忆/术语库上传到已有记忆库，支持xlsx/txt/tmx（术语库格式为xlsx/txt/tbx）三种格式，用户可下载模板参考。</p>
          <img src="../assets/imgs/help/upload.png" alt="">
          <p>记忆/术语库详情：支持按条目单条或批量编辑、删除记忆/术语库。</p>
          <img src="../assets/imgs/help/memory_details.png" alt="">
          <p>点击添加可输入原文译文，按条添加记忆/术语库。</p>
          <img src="../assets/imgs/help/tianjiajiyi.png" alt="">
          <span class="careful" style="margin-top:30px">新建记忆/术语库：</span>
          <span>可上传本地记忆/术语库，并在系统独立生成一个记忆/术语库，支持xlsx/txt/tmx（术语库格式为xlsx/txt/tbx）三种格式，用户可下载模板参考。</span><br>
          <img src="../assets/imgs/help/choice.png" alt="">
          <span class="careful" style="margin-top:30px">合并记忆/术语库：</span>
          <img src="../assets/imgs/help/hbjyk.png" alt="">
          <p class="distance">选中2个以上相同语言方向的记忆/术语库，填写库名，选择领域后，可将多个记忆/术语库合并为一个 记忆/术语库。</p>
        </div>
      </div>
      <div v-if="label =='团队管理'">
        <div class="wrap-two">
          <span class="wrap-two-header">团队管理</span>
          <h3>团队管理</h3>
          <p>查看和管理翻译团队。</p>
          <img src="../assets/imgs/help/team_management.png" alt="">
          <p>点击“微信邀请成员”跳转页面，生成二维码邀请成员加入团队。</p>
          <img src="../assets/imgs/help/fenxiang.png" alt="">
          <p>被邀请者扫码后，新成员即可参与项目协作。</p>
          <p>被邀请加入后，用户将拥有2个空间，个人空间和被邀请加入的团队空间，空间的所有任务、项目、翻译记忆各自独立，用户可在右上角自由切换。</p>
          <img class="distance" src="../assets/imgs/help/team_management.png" alt="">
        </div>
      </div>
      <div v-if="label =='用户中心'">
        <div class="wrap-two">
          <span class="wrap-two-header">用户中心</span>
          <h3>用户中心</h3>
          <p>用户可在个人查看个人信息，选择擅长语言和擅长领域。</p>
          <img src="../assets/imgs/help/personal_center.png" alt="">
          <p>选择擅长语言（最多3个）：</p>
          <img src="../assets/imgs/help/field.png" alt="">
          <p>选择擅长领域（最多3个）：</p>
          <img class="distance" src="../assets/imgs/help/language_pairs.png" alt="">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CommonHeader from '../common/header.vue'
export default {
  beforeRouteEnter (to, from, next) {
    //console.log(from);
    let fromName = from.name
    localStorage.setItem("fromName", fromName); // 路径
    next()
  },
  components:{
    CommonHeader
  },
  data () {
    return {
      data: [{ label: '上手指南', },
      { label: '进阶指南', },
      {
        label: '完整手册',
        children: [
          { label: '飞译CAT简介', },
          { label: '新建项目', },
          { label: '我的项目', },
          { label: '翻译编辑器', },
          { label: '我的任务', },
          { label: '翻译记忆', },
          { label: '团队管理', },
          // { label: '用户中心', },
        ]
      },
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // flag: 2,
      isopen: false,
      label: '上手指南',
      hospitalFlag: true,
      isVideo:false
    };
  },
  created () {
    // if (process.env.VUE_APP_INDEPENDENCE == "hospital") {
    //   this.hospitalFlag = false
    // } else {
    //   this.hospitalFlag = true
    // }
    if (this.$independence) {  // 私有部署 去掉 飞译CAT简介
      this.data[2].children.shift()
    }
    if (process.env.VUE_APP_HOSPITAL == "demo") {
      this.data.pop()
    }
    if (process.env.VUE_APP_HOSPITAL == "nationSchool") {
      this.isVideo = true
    }

  },
  mounted(){
window.addEventListener('scroll', this.scorll)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.scorll)
    })
  },
  methods: {
     scorll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 46) {
        document.querySelector('#headTop').style.backgroundColor = "#2a7aeb";
        document.querySelector('#headTop').style.top = "0";
      }
      if (scrollTop < 46) {
        document.querySelector('#headTop').style.backgroundColor = "";
        document.querySelector('#headTop').style.top = "auto"
      }
    },
    handleNodeClick (data) {
      this.label = data.label
      if (data.label == '完整手册') {
        this.label = '飞译CAT简介'
      }
    },
    goback () {
      // debugger
      // console.log(fromName);
      let fromName = localStorage.getItem('fromName');
      if (fromName !== "homepage") {
        fromName = 'home'
      } else {
        fromName = 'index'
      }
      this.$router.push(fromName)
    }
  }
};
</script>

<style lang="less" scoped>
.distance {
  margin-bottom: 40px;
  display: block;
}
.help-main {
  width: 100%;
  height: 100%;
  position: relative;
  .menu-bar {
    position: fixed;
    left: 0;
    top: 46px !important;
  }
  .goback {
    border-radius: 5px;
    width: 92px;
    height: 36px;
    position: absolute;
    left: 51px;
    top: 104px;
    z-index: 99;
    font-size: 18px;
  }
  .wrap-two {
    position: relative;
    width: 800px;
    height: 100%;
    top: 0;
    left: 60%;
    transform: translateX(-60%);
    //padding: 0 20% 0 20%;
    padding-top: 46px;
    padding-bottom: 20px;
  }
  .wrap-two-header {
    margin-top: 30px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    font-size: 30px;
    color: #333333;
  }
  .wrap-two-p1 {
    margin-top: 10px;
    margin-bottom: 21px;
  }
  .wrap-two-p2 {
    font-size: 18px;
    margin-top: 10px;
    li {
      list-style: disc !important;
      margin-top: 5px;
    }
  }
  .wrap-two-p3 {
    margin-top: 10px;
  }
  h3 {
    margin: 20px 0 10px 0;
  }
  p {
    margin: 20px 0px;
    font-size: 18px;
  }
  span {
    font-size: 18px;
    display: inline-block;
    margin: 5px 0;
  }
  img {
    border: 1px solid #d5d5d5;
  }
  .careful {
    font-weight: 800;
  }
}

/deep/.el-tree {
  box-sizing: border-box;
  padding-top: 198px;
  //padding-left: 23px;
  width: 217px;
  height: 2137px;
  background: #ebebeb;
  .el-tree-node {
    box-sizing: border-box;
    padding: 10px 0;
    color: #333333;
    font-size: 30px;
  }
  .el-tree-node:nth-child(1) {
    margin-top: 15px;
  }
}
/deep/.el-tree-node:hover {
  background-color: transparent;
}
/deep/.is-current {
  background-color: transparent;
  font-weight: 900 !important;
}

/deep/.el-tree-node__label {
  font-size: 18px;
}

/deep/.el-tree-node {
  font-weight: 500;
}
</style>
